module.exports = __webpack_public_path__ + "static/media/lunas.6a275637.png";